import AccountPONumberReducer from "@theStellarBlueprint/Store/Data/AccountPONumber/AccountPONumberReducer";
import CuttingToolCategoryReducer from "@theStellarBlueprint/Store/Data/CuttingToolCategory/CuttingToolCategoryReducer";
import CuttingToolConfigReducer from "@theStellarBlueprint/Store/Data/CuttingToolConfig/CuttingToolConfigReducer";
import CuttingToolPaginationReducer from "@theStellarBlueprint/Store/Data/CuttingToolPagination/CuttingToolPaginationReducer";
import LoadUserDetailsReducer from "@theStellarBlueprint/Store/Data/PurchasedItems/LoadPurchasedItemsReducer";
import LoadPurchasedItemsConfigReducer from "@theStellarBlueprint/Store/Data/PurchasedItemsConfig/LoadPurchasedItemsConfigReducer";
import { combineReducers } from "redux";

const customReducers = {
    LoadUserDetails: LoadUserDetailsReducer,
    LoadUserDetailsConfigSelection: LoadPurchasedItemsConfigReducer,
    CuttingToolConfig: CuttingToolConfigReducer,
    CuttingToolPagination: CuttingToolPaginationReducer,
    CuttingToolCategoryId:CuttingToolCategoryReducer,
    AccountPONUmberState: AccountPONumberReducer,
    
};

export type CustomDataReducers = typeof customReducers;

const customDataReducer = combineReducers(customReducers as any);

export default customDataReducer;
